import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data
	})
}

AuthService.simular = function (data) {
	return fetch({
		url: `/auth/simulation/${data}/login`,
		method: 'post',
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register/iniciar',
		method: 'post',
		data: data
	})
}

AuthService.confirmarRegistro = function (data) {
	// data = { email, token }
	return fetch({
		url: '/auth/register/confirmar',
		method: 'post',
		data: data
	})
}

AuthService.reenviarRegistro = function (email) {
	return fetch({
		url: '/auth/register/reenviar',
		method: 'post',
		data: { email }
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;